var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-layout',{attrs:{"loading":_vm.loading}},[(!_vm.loading)?[_c('d-header',{attrs:{"actions":[{
        label: _vm.$t('edit'),
        path: '/property-inspections/' + _vm.model.id + '/edit',
        primary: true,
        color: 'is-grey',
        icon: 'pencil'
      }]}},[_c('h1',{staticClass:"title"},[_c('d-previous-btn',{attrs:{"path":'/properties/' + _vm.$route.params.property + '/property-inspections'}}),_vm._v("\n        "+_vm._s(_vm.model.name)+"\n      ")],1)]),_vm._v(" "),_c('d-container',{attrs:{"paddingless-mobile":""}},[_c('d-card',{staticClass:"mb-0"},[_c('d-card-row',[_c('h2',{staticClass:"title is-5"},[_vm._v("\n            Details\n          ")]),_vm._v(" "),_c('ul',[_c('li',{staticClass:"mb-2"},[_vm._v("\n              "+_vm._s(_vm.model.name)+"\n            ")])])])],1)],1)]:_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }